import React, { useCallback } from 'react'
import styled from 'styled-components/macro'
import { Container, Typography, Button } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import { Add } from '@mui/icons-material'
import { usePermission } from '@tomfxs/permissions-client'

import GenericNotice from 'src/components/GenericNotice/GenericNotice'
import loadComponent from 'src/utils/loadMFE'
import { useFlightDeck } from 'src/context/FlightDeckContext'
import RouteContainer from 'src/components/App/RouteContainer'

const TrainerList = React.lazy(() => loadComponent('traiwiss', 'TrainerList'))

const StyledButton = styled(Button)`
    float: right;
`

const StyledHeadingText = styled(Typography)`
    margin-bottom: ${({ theme }) => theme.spacing(3)};
    float: left;
`

const StyledHeaderContainer = styled(Container)`
    height: 4vh;
`

export function TrainerIndexRoute() {
    const navigate = useNavigate()
    const { academy, openFlightDeck } = useFlightDeck()

    const canCreate = usePermission('traiwiss.trainer.create', { academy: academy?._id! })
    const canDelete = usePermission('traiwiss.trainer.delete', { academy: academy?._id! })

    const onCreate = useCallback(() => {
        navigate('/trainers/new')
    }, [navigate])

    return (
        <RouteContainer>
            <StyledHeaderContainer disableGutters>
                {canCreate && (
                    <StyledButton variant="contained" color="primary" onClick={() => onCreate?.()} startIcon={<Add />}>
                        neu
                    </StyledButton>
                )}
                <StyledHeadingText variant="h4">Trainer</StyledHeadingText>
            </StyledHeaderContainer>
            {!academy ? (
                <>
                    <GenericNotice
                        title="Keine Akademie ausgewählt"
                        message="Trainer gehören immer zu einer Akademie. Bitte wähle eine Akademie im Flight Deck aus, um dessen Trainer zu sehen">
                        <Button variant="contained" onClick={openFlightDeck}>
                            Flight Deck öffnen
                        </Button>
                    </GenericNotice>
                </>
            ) : (
                <TrainerList academyId={academy?._id} canDelete={canDelete} />
            )}
        </RouteContainer>
    )
}
